import React, { useEffect, useState } from 'react';
import ImageManagementTaskService from 'business/services/ImageManagementTaskService';
import { IImageManagementTaskDTO } from 'business/models/Models';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import {
  useOnStartImageTask,
  useUpdateIsSelectedTaskRunning,
} from './ImageManagementTask/hooks';
import { JobTypeDTO } from './ImageManagementTask/constants';
import { useGetBackgroundJobs } from 'redux/hooks/backgroundJobs';
import { RMRadioButton } from 'components/customComponents/Layers/InputGroups';
import { IStyle } from 'Styles';

interface ManageImagesProps {
  hideModal: () => void;
  expTreeNodeId: number;
}

export const ManageImages = (props: ManageImagesProps) => {
  const { hideModal, expTreeNodeId } = props;
  const [originalImageManagementTasks, setOriginalImageManagementTasks] = useState<
    IImageManagementTaskDTO[]
  >([]);
  const [imageManagementTasks, setImageManagementTasks] = useState<
    IImageManagementTaskDTO[]
  >([]);
  const [selectedTaskId, setSelectedTaskId] = useState<number>();
  const onStartImageTask = useOnStartImageTask();
  const setIsSelectedTaskRunning = useUpdateIsSelectedTaskRunning();
  const backgroundJobs = useGetBackgroundJobs();

  const handleTaskOnClick = (event) => {
    setSelectedTaskId(event.target.value);
  };

  useEffect(() => {
    const fetchTasksData = async () => {
      try {
        const imageManagementService = new ImageManagementTaskService();
        const result = await imageManagementService.getAllImageManagementTasks();
        setOriginalImageManagementTasks(result);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchTasksData();
  }, []);

  useEffect(() => {
    let filteredTasks = [...originalImageManagementTasks];
    backgroundJobs.forEach((job) => {
      filteredTasks = filteredTasks.filter(
        (item) => item.id != job.jobId && job.jobType == JobTypeDTO.ImageManangement,
      );
    });
    setImageManagementTasks(filteredTasks);
  }, [backgroundJobs.length, originalImageManagementTasks]);

  const startImageManagementTask = async () => {
    hideModal();
    const selectedTask = imageManagementTasks.find((task) => task.id == selectedTaskId);
    const selectedTaskTemp = { ...selectedTask };
    selectedTaskTemp.isPreview = false;
    selectedTaskTemp.explorerNodeIds = [expTreeNodeId];
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'Task has been Started.',
    );
    await onStartImageTask(selectedTaskTemp);
    setIsSelectedTaskRunning(true);
  };

  return (
    <div id="manageimages-wrapper" className="flex flex-col w-[100%] h-[280px]">
      <div id="manageimages-title" className="text-[1.077rem] text-[#5D5D5D] mb-2">
        Please select image management task, you want to execute.
      </div>
      <div
        id="manageimages-radiobuttons-wrapper"
        className="flex flex-col pt-3 overflow-scroll h-[200px] w-[100%] border border-solid border-[#E0E0E0]"
      >
        {imageManagementTasks?.map((task, index) => (
          <RMRadioButton
            key={'manageImageTaskRadio_' + task.id}
            selected={selectedTaskId}
            value={task.id}
            disabled={false}
            styleLabel={styles.optionLabelStyle}
            styleCircle={styles.styleRadioCircle}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '0.5rem',
            }}
            onClick={handleTaskOnClick}
            label={task.taskName}
          />
        ))}
      </div>
      <div
        id="manageimages-buttons-wrapper"
        className="flex flex-row h-[3.846rem] justify-end items-center"
      >
        <RMCustomButton
          title="CANCEL"
          onClick={hideModal}
          titleClass="text-[1.077rem] text-[#313131]"
          mainContainerClass="w-[6.769rem] h-[2.615rem] border border-solid rounded-[4px] border-[#B4B4B4]"
        />
        <RMCustomButton
          isDisabled={selectedTaskId ? false : true}
          title="RUN TASK"
          onClick={startImageManagementTask}
          titleClass={`text-[1.077rem] ${
            selectedTaskId ? 'text-[#FFFFFF]' : 'text-[#B4B4B4]'
          }`}
          mainContainerClass={`ml-[0.769rem] w-[7.769rem] h-[2.615rem] rounded-[4px] 
                        ${selectedTaskId ? 'bg-[#F7A246]' : 'bg-[#E0E0E0]'}`}
        />
      </div>
    </div>
  );
};

const styles: IStyle = {
  styleRadioCircle: {
    height: '1.25rem',
    width: '1.25rem',
    display: 'block',
  },
  optionLabelStyle: {
    fontWeight: 400,
    fontSize: '1rem',
    color: '#4F4F4F',
    marginLeft: '0.75rem',
  },
};
